import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import TcDashboard from './dashboard-tc-view';
import AdminDashboard from './dashboard-admin-view';

@inject('appStore')
@observer
export default class DashBoardView extends Component {
    constructor(props) {
        super(props);
    }

    handleClick(filter) {
        appStore.viewStore.openFilePageWithFilter(filter);
    }

    renderDashboard() {
        const user = this.props.appStore.coordinatorDetailStore.coordinator;
        if (user.hasRole('tc')) {
            return <TcDashboard handleClick={this.handleClick} />;
        }
        if (user.hasRole('admin') || user.hasRole('superadmin')) {
            return <AdminDashboard handleClick={this.handleClick} />;
        }
        return null;
    }

    render() {
        return <div> {this.renderDashboard()} </div>;
    }
}



// WEBPACK FOOTER //
// ./src/dashboard/dashboard-view.js